import React, { useEffect, useState } from "react";
import AddToTeamModal from "../components/common/modal/AddToTeamModal";
import CreateTeamModal from "../components/common/modal/CreateTeamModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentUserData,
  getIsLoggedIn,
  updateUser,
  verifySend,
} from "../store/users";
import {
  deleteInvitation,
  getCurrentUserInvitation,
} from "../store/invitations";
import { getGroupById } from "../store/groups";
import { getCurrentUserDeleteElem, removeDeletedElem } from "../store/delete";
import { useNavigate, useParams } from "react-router-dom";
import CreateRandomTeamModal from "../components/common/modal/CreateRandomTeamModal";
import CollectionPoin from "../ui/CollectionPoin";
import { removeGroupData } from "../service/http.localStorage";
import fonImage from "../img/fon.png";
import Button from "../components/common/Button";
import { useI18n } from "../i18n/LanguageContext";

function Main() {
  const [showModal, setShowModal] = useState({
    create: false,
    add: false,
    random: false,
  });
  const { country } = useParams();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn());
  const navigate = useNavigate();

  const currentUser = useSelector(getCurrentUserData());
  const { t } = useI18n();

  const onShowModal = () => {
    if (showModal === false) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  };

  const deletedElem = useSelector(getCurrentUserDeleteElem());
  const group = useSelector(getGroupById(currentUser && currentUser.teamId));

  const invitation = useSelector(getCurrentUserInvitation());
  useEffect(() => {
    // удаление в случае отказа и наличия delete элемента
    if (deletedElem !== undefined) {
      if (deletedElem.removeInvitation === true && invitation) {
        dispatch(deleteInvitation());
      }
      currentUser.teamId &&
        dispatch(updateUser({ ...currentUser, teamId: "" })) &&
        removeGroupData();

      dispatch(removeDeletedElem(deletedElem));
    }
  }, [deletedElem]);

  const handleSendVerify = () => {
    dispatch(verifySend());
    navigate(`verify`);
  };

  return (
    <div className="w-full min-h-[100dvh]">
      <div
        className="flex min-h-[100dvh] w-full flex-col items-center justify-center bg-cover bg-center bg-no-repeat px-3 py-6 md:bg-top"
        style={{ backgroundImage: `url(${fonImage})` }}
      >
        {group?.status === "build" && <CollectionPoin groupId={group?._id} />}
        {!invitation ? (
          <div></div>
        ) : (
          <CollectionPoin groupId={invitation?.groupId} />
        )}
        {currentUser && currentUser.isVerify ? (
          <div className="mt-4 flex w-full max-w-lg flex-col justify-center p-3 text-center sm:mt-16 sm:p-5">
            <h1 className="top-1/2  text-xl font-bold my-10 hover:text-white active:text-white focus:text-white">
              {group !== undefined ? (
                t("main.teamName", { name: group.teamname })
              ) : (
                <p
                  className="top-1/2 text-center text-xl text-white hover:text-blue-600 active:text-blue-600 focus:text-blue-600
                 border rounded-md bg-lime-600 px-5 py-4"
                >
                  {t("main.createAndGo")}
                </p>
              )}
            </h1>
            <p className="font-bold text-xl hover:text-white my-5">
              {group?.status === "build" &&
                t("main.waitMembers")}
            </p>
            <div className="grid grid-cols-1 gap-2 px-1 sm:grid-cols-2 sm:px-5">
              {/* <button
                className="bg-lime-300 text-black hover:bg-lime-500 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => setShowModal({ create: true })}
                disabled={currentUser === null ? true : false}
              >
                Create Team
              </button> */}
              <Button
                name="Create team"
                onClick={() => setShowModal({ create: true })}
                disabled={currentUser === null ? true : false}
              >
                {t("main.createTeam")}
              </Button>
              {showModal.create ? (
                <CreateTeamModal onShowModal={onShowModal} />
              ) : null}
              <button
                className="btn-smooth w-full rounded bg-lime-300 px-4 py-3 text-sm font-bold uppercase text-black shadow outline-none hover:bg-lime-500 hover:shadow-lg sm:px-6"
                type="button"
                onClick={() => setShowModal({ add: true })}
                disabled={invitation === undefined ? true : false}
              >
                {t("main.addTeam")}
              </button>
              {showModal.add ? (
                <AddToTeamModal onShowModal={onShowModal} />
              ) : null}
            </div>
            <div className="mx-1 my-5 sm:mx-5">
              <button
                className="btn-smooth mb-1 w-full rounded bg-lime-300 py-3 text-sm font-bold uppercase text-black shadow outline-none hover:bg-lime-500 hover:shadow-lg"
                type="button"
                onClick={() => setShowModal({ random: true })}
                disabled={currentUser === null ? true : false}
              >
                {t("main.dating")}
              </button>
              {showModal.random ? (
                <CreateRandomTeamModal onShowModal={onShowModal} />
              ) : null}
            </div>
          </div>
        ) : isLoggedIn ?? currentUser ? (
          <button
            className="btn-smooth mx-2 rounded bg-lime-300 px-6 py-3 text-sm font-bold uppercase text-black shadow outline-none hover:bg-lime-500 hover:shadow-lg"
            onClick={handleSendVerify}
          >
            {t("main.verify")}
          </button>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
}

export default Main;
